import { theme } from "../../theme"

export const defaultColors = [
  theme.color.purple9,
  theme.color.purple7,
  theme.color.amber9,
  theme.color.amber4,
]
